import { SEISMIC_SURVEY } from '@core/core/constants'
import type { BaseObjectProperties, Calculation, StickCalculation } from '@core/core/types'
import type { FC } from 'react'

import { SelectGroup } from '../../SelectGroup'

type StickObjectProps = {
  calculation: Calculation
  updateCalculation: (calc: Calculation) => void
}

export const StickObjects: FC<StickObjectProps> = ({ calculation, updateCalculation }) => {
  const params = calculation.params as StickCalculation
  const update = (value: BaseObjectProperties) => {
    updateCalculation({ ...calculation, params: { ...calculation.params, seismicSurvey: value } })
  }
  return (
    <SelectGroup
      type={SEISMIC_SURVEY}
      withParams={true}
      value={params.seismicSurvey}
      onChange={update}
    />
  )
}
